import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction, SuccessMessageAction} from "../components/CustomToast/actions";

export const LOADED_CHALLENGE_VERSIONS = '[challenge_versions] Loaded Challenge Versions';
export const LOADED_CHALLENGE_VERSIONS_PAGES = '[challenge_versions] Loaded pages';
export const LOADED_CHALLENGE_VERSIONS_TOTAL = '[challenge_versions] Loaded total';
export const LOADED_CHALLENGE_VERSIONS_CURRENT = '[challenge_versions] Loaded current';
export const LOADED_CHALLENGE_VERSIONS_LIMIT = '[challenge_versions] Loaded limit';
export const LOADED_CHALLENGE_CODE = '[challenge_code] Loaded challenge';
export const LOADED_CHALLENGES_UPDATES = '[challenges] Loaded updates';
export const LOADED_CHALLENGE_VERSION = '[challenge_version] Loaded Challenge Version';
export const LOADED_CHALLENGE_CODES = '[challenges] Loaded Challenge Codes';
export const LOADED_CHALLENGE_RESOURCES = '[challenge_resources] Loaded Challenge resources';
export const LOADED_CHALLENGE_VERSION_STREAM_ENTITIES = '[challenge_version] Loaded Stream Entities';
export const SET_CHALLENGE_PREVIEW_CURRENT_INDEX = '[challenge_preview] Set Current Index';
export const SET_CHALLENGE_PREVIEW_SHOW_REMINDER = '[challenge_preview] Set Show Reminder';
export const LOADED_MY_SCHOOL_CHALLENGES = '[challenges] Loaded my school Challenges';
export const SET_LIBRARY_SUBJECT = '[challenge_library] Set Challenge Library Subject';
export const SET_LIBRARY_TOPIC = '[challenge_library] Set Challenge Library Topic';
export const SET_LIBRARY_GRADE = '[challenge_library] Set Challenge Library Grade';
export const SET_LIBRARY_MEASURE = '[challenge_library] Set Challenge Library Measure';
export const SET_LIBRARY_THEME = '[challenge_library] Set Challenge Library Theme';

export const LoadChallengeVersionsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenge Versions')))
        .then(() => MindsetsJsSDK().API.get('challenge_versions', options))
        .then(response => {
            dispatch(LoadedChallengeVersionsAction(response.items));
            dispatch(LoadedChallengeVersionsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedChallengeVersionsLimitAction(response.limit));
            dispatch(LoadedChallengeVersionsPagesAction(response.pages));
            dispatch(LoadedChallengeVersionsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedChallengeVersionsAction = payload => ({
    type: LOADED_CHALLENGE_VERSIONS,
    payload
});
export const LoadedChallengeVersionsPagesAction = payload => ({
    type: LOADED_CHALLENGE_VERSIONS_PAGES,
    payload
});
export const LoadedChallengeVersionsTotalAction = payload => ({
    type: LOADED_CHALLENGE_VERSIONS_TOTAL,
    payload
});
export const LoadedChallengeVersionsCurrentAction = payload => ({
    type: LOADED_CHALLENGE_VERSIONS_CURRENT,
    payload
});
export const LoadedChallengeVersionsLimitAction = payload => ({
    type: LOADED_CHALLENGE_VERSIONS_LIMIT,
    payload
});

export const LoadChallengeCodeAction = (challenge_code_id, options) => dispatch => {
    return MindsetsJsSDK().API.get(`challenge_codes/${challenge_code_id}`, options).then(response => {
        dispatch(LoadedChallengeCodeAction(response.challenge_code));

        return response.challenge_code;
    });
};
export const LoadedChallengeCodeAction = payload => ({
    type: LOADED_CHALLENGE_CODE,
    payload
});

export const ImportChallengeAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.post(`challenge_versions/import`, data, options))
        .then(() => dispatch(SuccessMessageAction('Challenge imported')))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const ActivateChallengeAction = (challenge_code, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.patch(`challenge_versions/${challenge_code}/activate`, options))
        .then(() => dispatch(SuccessMessageAction('Challenge activated')))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const DisableChallengeAction = (challenge_code, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.patch(`challenge_versions/${challenge_code}/disable`, options))
        .then(() => dispatch(SuccessMessageAction('Challenge disabled')))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SoftUpdateAllChallengesAction = () => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.patch('challenge_versions/update/all'))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('All Challenges updated')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SoftUpdateChallengeContentAction = (challenge_code, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.patch(`challenge_codes/${challenge_code}/soft_update`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Challenge content updated')))
        .then(() => dispatch(LoadedChallengeUpdatesAction(null)));
};
export const CheckUpdatesAction = (challenge_version_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.get(`challenge_versions/${challenge_version_id}/updates`, options))
        .then(result => dispatch(LoadedChallengeUpdatesAction(result)))
        .then(() => dispatch(LoadingAction(false)));
};
export const LoadedChallengeUpdatesAction = payload => ({
    type: LOADED_CHALLENGES_UPDATES,
    payload
});
export const IncreaseChallengeVersionAction = (challenge_version_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Working')))
        .then(() => MindsetsJsSDK().API.put(`challenge_versions/${challenge_version_id}/update_content`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('New Challenge version created')))
        .then(() => dispatch(LoadedChallengeUpdatesAction(null)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const LoadChallengeVersionAction = (challenge_version_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenge Version')))
        .then(() => MindsetsJsSDK().API.get(`challenge_versions/${challenge_version_id}`, options))
        .then(response => {
            dispatch(LoadedChallengeVersionAction(response.challenge_version));

            return response.challenge_version;
        });
};
export const LoadedChallengeVersionAction = payload => ({
    type: LOADED_CHALLENGE_VERSION,
    payload
});

export const LoadChallengeCodesAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenges')))
        .then(() => MindsetsJsSDK().API.get('challenge_codes', options))
        .then(response => {
            dispatch(LoadedChallengeCodesAction(response.items));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedChallengeCodesAction = payload => ({
    type: LOADED_CHALLENGE_CODES,
    payload
});

export const LoadChallengeResourcesAction = (challenge_code, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenge resources')))
        .then(() => MindsetsJsSDK().API.get(`challenge_codes/${challenge_code}/resources`, options))
        .then(response => {
            dispatch(LoadedChallengeResourcesAction(response.resources));
            dispatch(LoadingAction(false));

            return response.resources;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedChallengeResourcesAction = payload => ({
    type: LOADED_CHALLENGE_RESOURCES,
    payload
});

export const LoadChallengeVersionStreamEntitiesAction = (challenge_version_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenge data')))
        .then(() => MindsetsJsSDK().API.get(`challenge_versions/${challenge_version_id}/entities`, options))
        .then(response => {
            dispatch(LoadedChallengeVersionStreamEntitiesAction(response.items));
            dispatch(LoadingAction(false));

            return response.items;
        });
};
export const LoadedChallengeVersionStreamEntitiesAction = payload => ({
    type: LOADED_CHALLENGE_VERSION_STREAM_ENTITIES,
    payload
});

export const SetChallengePreviewCurrentIndexAction = payload => ({
    type: SET_CHALLENGE_PREVIEW_CURRENT_INDEX,
    payload
});
export const SetChallengePreviewShowReminderAction = payload => ({
    type: SET_CHALLENGE_PREVIEW_SHOW_REMINDER,
    payload
});

export const CreateDistrictChallengeLockAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Adding a Challenge Lock')))
        .then(() => MindsetsJsSDK().API.post(`challenge_locks`, data, options))
        .then(() => dispatch(LoadingAction(false)));
};

export const LoadChallengeGuideAction = id => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading data')))
        .then(() => MindsetsJsSDK().API.get(`challenge_versions/${id}/guide`, {buffer: true}))
        .then(response => {
            dispatch(LoadingAction(false));

            return response;
        });
};

export const LoadMySchoolChallengesAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenges')))
        .then(() => MindsetsJsSDK().API.get('me/schools/challenges', options))
        .then(response => {
            dispatch(LoadedMySchoolChallengesAction(response.challenges));
            dispatch(LoadingAction(false));

            return response.challenges;
        });
};
export const LoadedMySchoolChallengesAction = payload => ({
    type: LOADED_MY_SCHOOL_CHALLENGES,
    payload
});

export const SetLibrarySubjectAction = payload => ({
    type: SET_LIBRARY_SUBJECT,
    payload
});
export const SetLibraryTopicAction = payload => ({
    type: SET_LIBRARY_TOPIC,
    payload
});
export const SetLibraryGradeAction = payload => ({
    type: SET_LIBRARY_GRADE,
    payload
});
export const SetLibraryMeasureAction = payload => ({
    type: SET_LIBRARY_MEASURE,
    payload
});
export const SetLibraryThemeAction = payload => ({
    type: SET_LIBRARY_THEME,
    payload
});
